import { FORGOT_PASSWORD_URL, INDEX_URL, NEW_PASSWORD_URL } from '@/constants';

const authRoutes = [INDEX_URL, FORGOT_PASSWORD_URL, NEW_PASSWORD_URL];

export function isNotAuthRoutes() {
  const currentPage = window.location.pathname;
  return !authRoutes.includes(currentPage);
}
